import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/Check circle.svg?react
const SvgCheckCircle = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M17 9L10.125 16L7 12.8182M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/CheckCircleIcon.tsx
function CheckCircleIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgCheckCircle,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { CheckCircleIcon as t };
//# sourceMappingURL=CheckCircleIcon-DMaJo-Du.js.map